import axios from '@axios'

export const state = {
  types: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allTypes: (state) => state.types,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPage: (state) => state.totalPage,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  CLEAR_TYPE_STATE: (state) => {
    state.types = []
    state.currentPage = 1
    state.perPage = 15
    state.totalPage = 1
    state.totalRecord = 0
  },
  GET_TYPES: (state, resp) => {
    if (!resp) return null
    state.types = resp.types
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPage = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  CREATE_TYPE: (state, car) => {
    // car.id = new Date().getTime()
    // state.cars.push(car)
  },
  UPDATE_TYPE: (state, car) => {
    // for (let i = 0; i < state.cars.length; i++) {
    //   if (state.cars[i].id === car.id) {
    //     car.id = new Date().getTime()
    //     for (let field in state.cars[i]) {
    //       state.cars[i][field] = car[field]
    //     }
    //     break
    //   }
    // }
  },
  REMOVE_TYPE: (state, deletedCar) => {
    // state.cars = state.cars.filter((car) => car.id !== deletedCar.id)
  },
}

export const actions = {
  async getTypes({ commit }) {
    commit('CLEAR_TYPE_STATE')
    await axios
      .get(`/api/types`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('CLEAR_TYPE_STATE')
          let data = Object.assign({}, resp.data)
          commit('GET_TYPES', data)
        }
      })
      .catch(() => {
        commit('GET_TYPES', null)
      })
  },
}
